import React from 'react';
import { Text } from '@billda/design-system';

interface SectionHeaderProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  icon,
  title,
  description,
}) => (
  <div className="flex items-start gap-3">
    <div className="mt-0.5 flex text-content-secondary">{icon}</div>
    <div>
      <Text variant="body1" className="font-semibold">
        {title}
      </Text>
      <Text variant="body2" color="secondary">
        {description}
      </Text>
    </div>
  </div>
);
